
export const fetchFile = async (archivoId, token) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}reportes/evidencias/archivos/${archivoId}`, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    });

    if (!response.ok) throw new Error('Error al obtener archivo');

    const data = await response.json();
    return data.archivo
    
  } catch (error) {
    return null;
  }
};

export const downloadFile = (blob, filename = 'archivo.pdf') => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};


export const openFileInNewTab = (blob) => {
  const url = URL.createObjectURL(blob);
  const w = window.open(url, '_blank', 'noopener,noreferrer');

  if (w) {
    const revoke = () => { try { URL.revokeObjectURL(url); } catch {} };
    w.onload = () => setTimeout(revoke, 60_000);
    setTimeout(revoke, 120_000);
  } else {
    setTimeout(() => URL.revokeObjectURL(url), 30_000);
  }
};

export const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const base64ToBlob = (base64, contentType = 'application/octet-stream') => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
};

export const base64ToFile = (base64, fileName, contentType = 'application/octet-stream') => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  return new File([byteArray], fileName, { type: contentType });
};

